import React, { useEffect, useState } from 'react'
import { apiRunWithAxios } from './APIRunWithAxios';
import { useDispatch, useSelector } from 'react-redux';
import DateService from '../../../../services/DateService'
import { eventTypes } from './EventTypes';
import TapSelect from '../../../../components/ui/TapSelect';
import { authLoginAndGetJWTToken } from '../../../../store/actions/OmniComm/OmniCommAuthAction';
import TapHelper from '../../../../services/TapHelper';
import Loader from '../../../../components/ui/Loader/Loader';
import { toast } from 'react-toastify';
import swal from 'sweetalert';

function RefuelingAndDrainingReport({formData}) {

    const dispatch                  =   useDispatch();
    const { data }                  =   useSelector(state => state.omniAuthLoginReducer);    
    const asset                     =   formData.asset;
    const[loading, setLoading]      =   useState(false);
    const[eventData, setEventData]  =   useState([]);

    useEffect(() => {
        if (data?.jwt) {
            getReportData()
        }
    }, [formData, data])
    
    const getReportData          =   async () => {
        
        const timeBegin     =   Math.floor(new Date(formData.date_range_start + " 00:00:00").getTime() / 1000);
        const timeEnd       =   Math.floor(new Date(formData.date_range_end + " 23:59:59").getTime() / 1000);
        setEventData([]);
        if(formData.asset_id && timeBegin && timeEnd) {
            setLoading(pre => !pre);
            try {
                const params        =   {
                    timeBegin,
                    timeEnd,
                }
                let response        =   await apiRunWithAxios(`https://online.omnicomm.in/ls/api/v1/reports/events/${formData.asset_id}`, "GET",  data?.jwt, params);
                const results       =   response.data?.events.filter(d => [1,2,3,4].includes(d.type));
                if(results) {
                    let refuelingStart  =   results.filter(d => [1].includes(d.type))
                    let refuelingEnd    =   results.filter(d => [2].includes(d.type))
                    let drainStart      =   results.filter(d => [3].includes(d.type))
                    let drainEnd        =   results.filter(d => [4].includes(d.type))
    
                    refuelingStart      =   refuelingStart.map((d, i) => ({...d, endTimeStamp: refuelingEnd?.[i]?.timestamp}))
    
    
                    drainStart          =   drainStart.map((d, i) => ({...d, endTimeStamp: drainEnd?.[i]?.timestamp}))
    
                    let finalData       =   [...refuelingStart, ...drainStart].sort((a, b) => a.timestamp - b.timestamp);

                    setEventData(finalData);
                }

                setLoading(false);
            } catch (error) {
                setLoading(false);
                if(error?.response?.status === 401 && error?.response?.data?.error === "Unauthorized") {
                    swal({
                        title: "Refresh",
                        text: "Please refresh again for fetch report data.",
                        icon: "warning",
                        // dangerMode: true,
                        buttons: ["Cancel", "Refresh"],
                    }).then(willDelete => {
                        if (willDelete) {
                            dispatch(authLoginAndGetJWTToken());
                        }
                    });
                }
            }finally{
                setLoading(false);
            }
        }else {
            if(!formData.uuid) {
                toast.error('The asset information you provided is incorrect.', { position: toast.POSITION.TOP_RIGHT });
            }else {
                toast.error('Time period is required, for event data', { position: toast.POSITION.TOP_RIGHT });
            }
        }        
    }

    return (
        <>
            <table className="table table-hover table-bordered mt-1 table-fixed" style={{ zIndex: 2, position: "relative" }}>
                <thead className="table-secondary">
                    <tr>
                        <th className='text-center' style={{ width: "5%" }}>#</th>
                        <th style={{ width: "20%" }}>Asset</th>
                        <th style={{ width: "20%" }}>Start time</th>
                        <th style={{ width: "20%" }}>End time</th>
                        <th className='text-center' style={{ width: "20%" }}>Event</th>
                        <th style={{ width: "15" }}>Volume, L</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        loading 
                        ?
                        <tr className='text-center'><td colSpan={6}><Loader/></td></tr>
                        :
                        eventData && eventData.length > 0 
                        ?
                        eventData.map((d, i) => {
                            let parameters = null
                            if(d.parameters) {
                                if([1,3].includes(d.type)) {
                                    parameters = TapHelper.numberFormatter(d.parameters[1])
                                } 
                            }
                            return <tr className={d?.type == 1 ? '' : 'table-danger'} key={i}>
                                <td className='text-center'>{i+1}</td>
                                <td className="fs14 fw-normal" >{asset?.name}</td>
                                <td className=''>{DateService.SecToDateTimeFormat(d.timestamp)}</td>
                                <td className=''>{DateService.SecToDateTimeFormat(d.endTimeStamp)}</td>
                                <td className='text-center'>{d?.type == 1 ? 'Refueling' : 'Draining'}</td>
                                <td className=''>{parameters}</td>
                            </tr>
                        })
                        :
                        <tr className='text-center'><td colSpan={6}>No Record Found</td></tr>
                    }
                </tbody>
            </table>
        </>

    )
}

export default RefuelingAndDrainingReport